import config from '../config';
import { ENV } from '../env';

import { createOktaAuth } from './oktaAuth';

export const oktaAuth = createOktaAuth(ENV, config, window.location);
